import { render, staticRenderFns } from "./customview.vue?vue&type=template&id=6735d24b"
import script from "./customview.vue?vue&type=script&lang=js"
export * from "./customview.vue?vue&type=script&lang=js"
import style0 from "./customview.vue?vue&type=style&index=0&id=6735d24b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports